import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter'
import Moment from 'react-moment'
import moment from 'moment'
import CircularProgress from '@material-ui/core/CircularProgress'

import { MEDIA_PREFERENCE, BRAND_PREFERENCE, DEMOGRAPHICS, ANTICIPATION } from '../../constants/commons'
import { TableFormats } from '../TableHelpers'
import AudienceFilterComponent from './filter/AudienceFilterComponent'
import { VIDEO, CHANNEL } from '../../constants/tlm'
import { DefaultFilters } from '../../reducers/topics_reducer'
import { MediaPrefrence, PlanFilters } from '../../classes/FilterHelpers'
import * as f from '../../classes/Filters'
import DateHelpers from '../../classes/DateHelpers'
import Thumbnail from '../widgets/Thumbnail'

export default class AudienceRecoComponent extends React.Component {
  static propTypes = {
    topicPlan: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      currentPage: PropTypes.number.isRequired,
      error: PropTypes.object,
      details: PropTypes.object,
      endOfResult: PropTypes.bool.isRequired
    }).isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    shortcutPreference: PropTypes.string,
    filters: PropTypes.object.isRequired,
    selectedPlanFilters: PropTypes.object.isRequired,
    programmingFilters: PropTypes.array.isRequired,
    otherFilters: PropTypes.array,
    setFilters: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,
    loadMore: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    isAnticipation: PropTypes.bool,
    fetchTopicPlan: PropTypes.func
  }

  constructor (props) {
    super(props)
    this.state = {
      filterIcon: false,
      page: 0,
      rowsPerPage: 200,
      totalPages: 0,
      isLoading: false,
      defaultFilter: DefaultFilters
    }
    this.recosListRef = React.createRef()
  }

  componentDidMount () {
    this.setDefaultFilterForModule ()
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.topicPlan !== this.props.topicPlan && this.props.topicPlan.details && this.props.topicPlan.details.recommendations) {
      const totalPages = Math.round(this.props.topicPlan.details.recommendations.length / this.state.rowsPerPage)
      this.setState({ totalPages: totalPages})
    }
    if (prevProps.location !== this.props.location) {
      this.setDefaultFilterForModule ()
    }
    if (prevState.page !== this.state.page) {
      /* eslint-disable no-unused-expressions */
      setTimeout(() => {
        this.setState({ isLoading: false}),
        1000
      })
    }
  }

  setDefaultFilterForModule () {
    if (this.props.location.pathname.includes(MEDIA_PREFERENCE)) {
      this.setState({ defaultFilter: MediaPrefrence })
    } else if (this.props.location.pathname.includes(BRAND_PREFERENCE)) {
      this.setState({ defaultFilter: PlanFilters.Brand })
    } else if (this.props.location.pathname.includes(DEMOGRAPHICS)) {
      this.setState({ defaultFilter: PlanFilters.Lifestyle })
    } else if (this.props.location.pathname.includes(ANTICIPATION)) {
      this.setState({ defaultFilter: f.Filters.Common.AnticipationShowMovie })
    }
  }

  render () {
    const isAnticipationClass = this.props.isAnticipation ? 'widthControl4' : 'widthControl2'
    const tableClasses = `recoTable forHeadStick borderBox tableUI2 scrollHeightContorl2 pullUpforHeadFix mintableheight ${isAnticipationClass}`
    const numFiltersApplied = this.props.filters.equals(this.state.defaultFilter)
    return (
      <>
        <AudienceFilterComponent
          filterIcon={this.state.filterIcon}
          filters={this.props.filters}
          selectedPlanFilters={this.props.selectedPlanFilters}
          programmingFilters={this.props.programmingFilters}
          otherFilters={this.props.otherFilters}
          setFilters={this.props.setFilters}
          resetFilters={this.props.resetFilters}
          location={this.props.location}
          setFilterIcon={this.setFilterIcon}
          shortcut={this.props.shortcut}
          shortcutPreference={this.props.shortcutPreference}
          fetchTopicPlan={this.props.fetchTopicPlan}
        />
        <div className={tableClasses} ref={this.recosListRef} onScroll={ this.loadMoreOnScroll }>
          <AudienceList
            topicPlan={this.props.topicPlan}
            filters={this.props.filters}
            setFilterIcon={this.setFilterIcon}
            isAnticipation={this.props.isAnticipation}
            page={this.state.page}
            rowsPerPage={this.state.rowsPerPage}
            numFiltersApplied={numFiltersApplied}
            fetchTopicPlan={this.props.fetchTopicPlan}
          />
          { (this.props.topicPlan.isFetching && this.props.topicPlan.currentPage > 1 && !this.props.filters.empty()) &&
            <div className='loadingProgress loadingMore'>
              <CircularProgress />
              <span className='loading'>Loading more results</span>
            </div>
          }
        </div>
      </>
    )
  }

  setFilterIcon = () => {
    this.setState({ filterIcon: !this.state.filterIcon })
  }

  loadMoreOnScroll = () => {
    // If we haven't even loaded a page of results yet, do not auto-load more...
    if (!this.props.topicPlan.details) {
      return
    }
    // If we're at the end of the results, don't load more
    if (this.props.topicPlan.endOfResult) {
      // console.log('end of results, skipping load more')
      return
    }

    // If the current filters are empty, then skip auto-load more. This happens when you choose
    // "Deselect All" in the Content Type filters.
    if (this.props.filters.empty()) {
      return
    }

    // If we are actively in the process of loading more, do not auto-load more
    if (this.props.topicPlan.currentPage <= 1 && this.props.topicPlan.isFetching) {
      return
    }
    // if (this.state.page === this.state.totalPages) {
    //   return
    // }
    let scrollHeight = this.recosListRef.current.children[0].children[0].children[1].scrollHeight
    let offsetHeight = this.recosListRef.current.children[0].children[0].children[1].offsetHeight
    let scrollTop = this.recosListRef.current.children[0].children[0].children[1].scrollTop
    let clientHeight = this.recosListRef.current.children[0].children[0].children[1].clientHeight
    if (((scrollTop + clientHeight) >= (scrollHeight - offsetHeight)) && !this.props.topicPlan.isFetching) {
      this.props.loadMore(scrollTop)
      this.setState({
        page: this.state.page + 1,
        isLoading: true
      })
    }
  }
}

const AudienceList = ({topicPlan, filters, setFilterIcon, isAnticipation, page, rowsPerPage, numFiltersApplied, fetchTopicPlan}) => {
  let recos = (topicPlan.details || {}).recommendations
  recos = recos.slice(0, page * rowsPerPage + rowsPerPage)
  const noDataText = () => {
    if (topicPlan.isFetching && !filters.empty()) {
      return (
        <div className='loadingProgress'>
          <CircularProgress />
          <span className='loading'>Fetching audience data</span>
        </div>
      )
    } else {
      return (
        <div className='loadingProgress'>
          <span className='loading'>No recommendations match your filter criteria</span>
        </div>
      )
    }
  }
  const iconFormatter = (cell) => {
    return cell
  }

  const thumbnailFormatter = (cell, row) => {
    const style = {
      width: 40,
      height: 40,
      borderRadius: 5,
      boxShadow: '0px 0px 1px 0px #070707'
    }
    return (
      <Thumbnail
        entityOverrideImage={(cell && cell.indexOf('http') === -1) ? cell : null}
        thumbnail={(cell && cell.indexOf('http') > -1) ? cell : null}
        name={row.topic_name}
        imageDivStyle={style}
        noImgTextClass={'audienceNoImgText'}
        noImgClass={'audienceNoImg'}
        divId={`audience_img_${row.topic_id}`}
      />
    )
  }
  const settingFormatter = () => {
    const style = {
      width: 32,
      height: 32,
      backgroundImage: numFiltersApplied ? 'url(/static/images/withoutFilter.png)' : 'url(/static/images/withFilter.png)',
      backgroundColor: 'transparent',
      backgroundSize: '100%',
      border: 0,
      padding: 0,
      marginTop: -5,
      marginLeft: -4,
      textAlign: 'right',
      paddingRight: '10px',
      fontSize: '18px',
      lineHeight: '22px',
      color: '#FFFFFF',
      cursor: 'pointer'
    }
    return (
      <Button id='filter' style={style} className="filterIconImg"></Button>
    )
  }

  const headFormatter = (column, colIndex, {sortElement, filterElement}) => {
    return (
      <div className="search_holder">
        <div className="head_label">
          { column.text }{ sortElement }
        </div>
        <div className="head_search">
          { filterElement }
        </div>
      </div>
    )
  }
  const nameFormatter = (cell, row) => {
    if (row.topic_subtype === VIDEO || row.topic_subtype === CHANNEL) {
      return (
        <a href={row.link} target="_blank" className="trending-thumbnail-style" rel="noopener noreferrer">
          {cell}
        </a>
      )
    }
    if (row.entity_localization_override && row.entity_localization_override.length > 0 && row.entity_localization_override[0].display_name) {
      return row.entity_localization_override[0].display_name
    }
    return cell
  }
  const dateFormatter = (cell, row) => {
    if (row.topic_type === VIDEO) {
      return null
    }
    if (cell) {
      const premiereDate = moment(DateHelpers.getDateWithoutTime(cell))
      if (DateHelpers.isYearEndDate(premiereDate)) {
        return <Moment format="YYYY">{premiereDate}</Moment>
      }
      return (
        <Moment format="MM.DD.YYYY">{premiereDate}</Moment>
      )
    }
    return null
  }
  const filterByName = (cell, row) => {
    fetchTopicPlan('media', 'search', cell.toLowerCase(), true)
    return row
  }
  const columns = [
    {
      dataField: 'row_id',
      text: '',
      headerFormatter: settingFormatter,
      headerEvents: {
        onClick: () => setFilterIcon()
      }
    },
    {
      dataField: 'thumbnail',
      text: '',
      formatter: thumbnailFormatter,
      headerStyle: () => {
        return {
          width: 50
        }
      }
    },
    {
      dataField: 'topic_name',
      text: '',
      formatter: nameFormatter,
      sort: true,
      filter: textFilter({ placeholder: 'NAME', autoComplete: 'off', onFilter: filterByName}),
      headerClasses: () => {
        return 'forinputResize'
      }
    },
    {
      dataField: 'topic_subtype',
      text: 'TYPE',
      sort: true,
      headerFormatter: headFormatter,
      formatter: iconFormatter
    },
    {
      dataField: 'active_date',
      text: 'RELEASE DATE',
      sort: true,
      sortFunc: (a, b, order) => {
        if (order === 'asc') {
          return new Date(a) - new Date(b) }
        else {
          return new Date(b) - new Date(a) }
      },
      hidden: isAnticipation ? false : true,
      formatter: dateFormatter
    },
    {
      dataField: 'category',
      text: 'CATEGORY',
      sort: true
    },
    {
      dataField: 'score',
      text: 'AFFINITY',
      sort: true,
      formatter: TableFormats.formatRelevancyNumber
    }
  ]

  const defaultSorted = [{
    dataField: 'score',
    order: 'desc'
  }]

  return (
    <BootstrapTable
      keyField='row_id'
      data={ recos }
      columns={ columns }
      bordered={ true }
      filter={ filterFactory() }
      noDataIndication={noDataText}
      defaultSorted={defaultSorted}
      />
  )
}

AudienceList.propTypes = {
  topicPlan: PropTypes.shape({
    isFetching: PropTypes.bool.isRequired,
    error: PropTypes.object,
    details: PropTypes.object,
    endOfResult: PropTypes.bool.isRequired
  }).isRequired,
  filters: PropTypes.object.isRequired,
  setFilterIcon: PropTypes.func.isRequired,
  numFiltersApplied: PropTypes.bool,
  isAnticipation: PropTypes.bool,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  fetchTopicPlan: PropTypes.func
}
